import { render, staticRenderFns } from "./InvoiceDraftsTable.vue?vue&type=template&id=56aa9628&"
import script from "./InvoiceDraftsTable.vue?vue&type=script&lang=js&"
export * from "./InvoiceDraftsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports